import { CoreIcon } from '../core-icon';
import couponSVG from '../../../src/images/icons/coupon.svg';

export const CouponIcon = props => {
  return <CoreIcon src={couponSVG} {...props} />;
};
